var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Dashboard, Property 2=ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007676"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 5,
    y: 4,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 14.168,
    y: 4,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 5,
    y: 13.375,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 14.168,
    y: 13.375,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDashboard);
export default __webpack_public_path__ + "static/media/selected-dashboard.911912eafe4ded692306dc999222684f.svg";
export { ForwardRef as ReactComponent };